export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'

export const concourseId = {
  DEV: {
    'es-CO': 449,
    'es-EC': 450,
    'es-PE': 451,
    'es-BO': 452,
    'es-AR': 453,
    'es-DO': 454,
    'es-PY': 457,
    'es-CL': 461,
  },
  PDN: {
    'es-CO': 760,
    'es-PE': 765,
    'es-EC': 764,
    'es-AR': -1,
    'es-BO': -1,
    'es-DO': -1,
    'es-PY': -1,
    'es-CL': -1,
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const gameId = {
  DEV: {
    'es-CO': 139,
    'es-EC': 140,
    'es-PE': 141,
    'es-BO': 142,
    'es-AR': 143,
    'es-DO': 144,
    'es-PY': 145,
    'es-CL': 146,
  },
  PDN: {
    'es-CO': 269,
    'es-PE': 271,
    'es-EC': 270,
    'es-AR': -1,
    'es-BO': -1,
    'es-DO': -1,
    'es-PY': -1,
    'es-CL': -1,
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const costActivity = {
  'es-CO': 20,
  'es-EC': 20,
  'es-BO': 0,
  'es-PE': 20,
  'es-AR': 20,
  'es-DO': 30,
  'es-PY': 20,
  'es-CL': 30,
}[LOCALE]
export const activity_dates = ['xx-01-xxxx', 'xx-01-xxxx']

export const topNumber =
  {
    'es-CO': 20,
    'es-EC': 10,
    'es-BO': 10,
    'es-PE': 10,
    'es-DO': 10,
    'es-PY': 5,
    'es-CL': 10,
  }[LOCALE] || 10

export const costHelpActivity = 10

const videoBonusByCountry = {
  default: 'https://www.youtube.com/watch?v=-yj4fhWHhzE',
  'es-EC': 'https://www.youtube.com/watch?v=-yj4fhWHhzE',
  'es-AR': 'https://www.youtube.com/watch?v=JGM5-xwGZw4',
}

export const preGameUrlVideos = {
  video: [
    videoBonusByCountry[process.env.LOCALE] || videoBonusByCountry['default'],
  ],
}
